import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "busy-indicator-container"
}
const _hoisted_2 = { class: "last-updated" }
const _hoisted_3 = { class: "table-controls" }

import { onMounted, ref } from 'vue'

import BusyIndicator from '@/components/common/BusyIndicator.vue'
import CardContainer from '@/components/common/CardContainer.vue'
import NotificationBanner from '@/components/common/NotificationBanner.vue'
import PrintButton from '@/components/common/PrintButton.vue'
import LeagueRundownTable from '@/components/widgets/public/LeagueRundownTable.vue'
import LeagueStandingsTable from '@/components/widgets/public/LeagueStandingsTable.vue'
import { useLeaguesStore } from '@/store/public/leagues'
import { getErrorMessage } from '@/utils/error-handling'
import { formatDate } from '@/utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'LeagueStandingsView',
  setup(__props) {

const leagues = useLeaguesStore()

const errorMessage = ref<string | null>(null)
const isLoading = ref<boolean>(false)

onMounted(async () => {
  errorMessage.value = null
  isLoading.value = true

  try {
    await leagues.fetchLeagueStandings()
  } catch (e) {
    const message = getErrorMessage(e as Error)
    console.error(`Failed fetching league standings: ${message}`)
    errorMessage.value = message
  }

  isLoading.value = false
})

return (_ctx: any,_cache: any) => {
  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("h1", _hoisted_1, [
        _createVNode(BusyIndicator)
      ]))
    : (errorMessage.value)
      ? (_openBlock(), _createBlock(NotificationBanner, {
          key: 1,
          message: errorMessage.value,
          "is-danger": ""
        }, null, 8, ["message"]))
      : ((_unref(leagues).selectedLeague?.standings?.sections ?? []).length === 0)
        ? (_openBlock(), _createBlock(NotificationBanner, {
            key: 2,
            message: _ctx.$t('leagues.errors.no-league-results'),
            "is-warning": ""
          }, null, 8, ["message"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("h4", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('leagues.labels.last-updated')) + ": ", 1),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(formatDate)(new Date(_unref(leagues).selectedLeague?.standings?.timestamp))), 1)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(PrintButton)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leagues).selectedLeague?.standings?.sections, (section, i) => {
              return (_openBlock(), _createBlock(CardContainer, {
                key: `section-${i}`,
                title: _ctx.$t('leagues.labels.section', { section: section.number })
              }, {
                default: _withCtx(() => [
                  ((section.rows ?? []).length === 0)
                    ? (_openBlock(), _createBlock(NotificationBanner, {
                        key: 0,
                        message: _ctx.$t('leagues.errors.no-section-results'),
                        "is-warning": ""
                      }, null, 8, ["message"]))
                    : (_openBlock(), _createBlock(LeagueStandingsTable, {
                        key: 1,
                        rows: section.rows
                      }, null, 8, ["rows"])),
                  ((section?.rundown ?? []).length > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("h4", null, _toDisplayString(_ctx.$t('leagues.labels.rundown')), 1),
                        _createVNode(LeagueRundownTable, {
                          rows: section.rundown
                        }, null, 8, ["rows"])
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["title"]))
            }), 128))
          ], 64))
}
}

})